export default __webpack_public_path__ + "static/media/icon-card-custom-fields-formatting.94038809.svg";